import './About.css';

const About = () => {
  return (
    <div className="about">
      <section className="about-hero">
        <h1>About Us</h1>
      </section>

      <section className="about-intro">
        <h2>Welcome to AURA Ayurveda & Wellness</h2>
        <p>
          Established with a vision to bring authentic Kerala Ayurvedic healing to our community, 
          AURA Ayurveda & Wellness has been serving for over a decade. We specialize in traditional 
          Kerala Ayurvedic massage therapy using pure natural herbal oils for holistic healing and wellness.
        </p>
        <p>
          Our certified Ayurvedic therapists are trained in ancient Kerala traditions, combining 
          time-tested wisdom with modern wellness practices. Experience authentic treatments for 
          stress relief, detoxification, deep relaxation, and complete body rejuvenation.
        </p>
      </section>

      <section className="mission-vision">
        <div className="mv-container">
          <div className="mv-card">
            <div className="mv-icon">�</div>
            <h3>Our Mission</h3>
            <p>
              To provide authentic Kerala Ayurvedic massage therapy and wellness services that 
              promote natural healing, stress relief, and holistic well-being. We are committed 
              to preserving traditional Ayurvedic practices while making them accessible to everyone.
            </p>
          </div>
          <div className="mv-card">
            <div className="mv-icon">🧘</div>
            <h3>Our Vision</h3>
            <p>
              To be the most trusted destination for authentic Kerala Ayurvedic treatments, 
              setting standards in natural healing and wellness through traditional methods, 
              pure herbal oils, and personalized care.
            </p>
          </div>
        </div>
      </section>

      <section className="experience-section">
        <h2>Our Journey in Numbers</h2>
        <div className="stats-grid">
          <div className="stat-item">
            <div className="stat-number">10+</div>
            <div className="stat-label">Years Experience</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">50K+</div>
            <div className="stat-label">Happy Clients</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">25+</div>
            <div className="stat-label">Expert Therapists</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">100%</div>
            <div className="stat-label">Natural Herbal Oils</div>
          </div>
        </div>
      </section>

      <section className="team-section">
        <h2>Our Expert Team</h2>
        <p className="team-description">
          Our team consists of certified Ayurvedic therapists and wellness professionals with 
          extensive training in traditional Kerala massage techniques. Each member is dedicated 
          to providing authentic healing experiences.
        </p>
        <div className="team-grid">
          <div className="team-card">
            <div className="team-icon">🌿</div>
            <h3>Ayurvedic Therapists</h3>
            <p>Kerala Massage Experts</p>
            <span>Certified in traditional Kerala Ayurvedic massage techniques and herbal therapy</span>
          </div>
          <div className="team-card">
            <div className="team-icon">💆</div>
            <h3>Wellness Specialists</h3>
            <p>Holistic Healing</p>
            <span>Trained in stress relief, detoxification, and complete body wellness programs</span>
          </div>
          <div className="team-card">
            <div className="team-icon">✨</div>
            <h3>Beauty Therapists</h3>
            <p>Skin & Hair Care</p>
            <span>Expert in natural beauty treatments using herbal products and traditional methods</span>
          </div>
          <div className="team-card">
            <div className="team-icon">�</div>
            <h3>Hair Stylists</h3>
            <p>Professional Styling</p>
            <span>Skilled in modern hair styling, coloring, and treatments for men and women</span>
          </div>
        </div>
      </section>

      <section className="values-section">
        <h2>Our Core Values</h2>
        <div className="values-grid">
          <div className="value-card">
            <div className="value-icon">🌿</div>
            <h3>100% Natural</h3>
            <p>We use only pure, authentic Kerala herbal oils prepared using traditional methods</p>
          </div>
          <div className="value-card">
            <div className="value-icon">🏛️</div>
            <h3>Traditional Methods</h3>
            <p>Authentic Kerala Ayurvedic practices passed down through generations</p>
          </div>
          <div className="value-card">
            <div className="value-icon">👨‍⚕️</div>
            <h3>Certified Experts</h3>
            <p>Trained professionals with expertise in Ayurvedic healing and wellness</p>
          </div>
          <div className="value-card">
            <div className="value-icon">💯</div>
            <h3>Hygiene Standards</h3>
            <p>Strict sanitization protocols ensuring your safety and comfort</p>
          </div>
          <div className="value-card">
            <div className="value-icon">🎯</div>
            <h3>Personalized Care</h3>
            <p>Customized treatments tailored to your specific health and wellness needs</p>
          </div>
          <div className="value-card">
            <div className="value-icon">⭐</div>
            <h3>Premium Experience</h3>
            <p>Serene ambiance designed for complete relaxation and rejuvenation</p>
          </div>
        </div>
      </section>

      <section className="gallery-section">
        <h2>Our Wellness Center</h2>
        <div className="gallery-grid">
          <div className="gallery-item">🌿</div>
          <div className="gallery-item">💆</div>
          <div className="gallery-item">🧘</div>
          <div className="gallery-item">✨</div>
          <div className="gallery-item">🛋️</div>
          <div className="gallery-item">💧</div>
        </div>
      </section>
    </div>
  );
};

export default About;
